const panel     = document.getElementById('info-panel');
const overlay   = document.getElementById('overlay');
const imgEl     = document.getElementById('info-image');
const titleEl   = document.getElementById('info-title');
const extractEl = document.getElementById('info-extract');
const linkEl    = document.getElementById('info-link');
const closeBtn  = document.getElementById('info-close');

function closeInfoPanel() {
  panel.classList.remove('open');
  overlay.classList.remove('active');
}


function adjustFontSize(elem) {
  const len = elem.textContent.length;
  if (len < 200) {
    elem.style.fontSize = 'var(--font-large)';
  } else if (len < 500) {
    const ratio = (len - 200) / 300; 
    const size =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--font-large')) -
      ratio *
        (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--font-large')) -
         parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--font-small')));
    elem.style.fontSize = `${size}rem`;
  } else {
    elem.style.fontSize = 'var(--font-small)';
  }
}

export async function showInfoPanel(name) {

  panel.classList.remove('open');
  overlay.classList.remove('active');
  titleEl.textContent   = 'Loading…';
  extractEl.textContent = '';
  imgEl.style.display   = 'none';
  linkEl.href           = '#';

  const spinner = document.getElementById('info-loading');
  spinner.classList.add('active');

  try {
    const resp = await fetch(
      `https://en.wikipedia.org/api/rest_v1/page/summary/${encodeURIComponent(name)}`
    );
    if (!resp.ok) throw new Error('Not found');
    const data = await resp.json();


    titleEl.textContent   = data.title;
    extractEl.textContent = data.extract || 'No description available.';
    adjustFontSize(extractEl);

    let imgPromise = Promise.resolve(null);
    if (data.thumbnail?.source) {
      imgPromise = new Promise((resolve, reject) => {
        const tmp = new Image();
        tmp.src = data.thumbnail.source;
        tmp.onload = () => resolve(tmp);
        tmp.onerror = reject;
      });
    }

    const loadedImg = await imgPromise;

    if (loadedImg) {
      imgEl.setAttribute('src', loadedImg.src);
      imgEl.alt = data.title;
      imgEl.style.display = 'block';
    }

    linkEl.href =
      data.content_urls?.desktop?.page ||
      `https://en.wikipedia.org/wiki/${encodeURIComponent(name)}`;

  } catch {
    titleEl.textContent   = name;
    extractEl.textContent = 'Could not fetch data.';
    adjustFontSize(extractEl);
    linkEl.href = `https://en.wikipedia.org/wiki/${encodeURIComponent(name)}`;
  } finally {

    spinner.classList.remove('active');
    setTimeout(() => {
      panel.classList.add('open');
      overlay.classList.add('active');
    }, 10);
  }
}


closeBtn.addEventListener('click', closeInfoPanel);
overlay.addEventListener('click', closeInfoPanel);


